import { language } from "shared/language";

export const ICON_EXISTED = language.icon_existed;
export const ICON_NOT_FOUND = language.icon_not_found;
